import {Cardpreview, CardpreviewContent} from 'layout/preview/cardpreview'
import {
	DPOverviewBlock,
	DPOverviewItemBlock,
	DPOverviewLinkBlock,
	DPOverviewVideoBlock
} from 'types/DPTypes'

import {Block} from 'blocks/block'
import {VideoBlock} from 'blocks/videoblock/videoblock'
import {Textpreview} from 'layout/preview/textpreview'
import {Theme} from 'layout/theme'
import React from 'react'
import {fromModule} from 'util/styler/Styler'
import {useIDFromAnchorBlock} from 'util/useAnchor'
import css from './overview.module.scss'

const styles = fromModule(css)

type OverviewDisplaysType = {
	display_textual?: boolean
}

export const Overview: React.FC<DPOverviewBlock> = (data) => {
	const {
		_type,
		title,
		columns = 3,
		items,
		textual_display,
		white_background
	} = data
	const id = useIDFromAnchorBlock(data)
	if (!items || items.length === 0) return null
	const bgwhite = white_background
	const display_textual = textual_display

	return (
		<Block
			type={_type}
			anchorID={id}
			className={styles.overview.mod({bgwhite}).mod(`columns${columns}`)()}
		>
			<Theme.Container>
				{title && (
					<div className={styles.overview.title()}>
						<Theme.H2 mod="blueline">{title}</Theme.H2>
					</div>
				)}
				<div className={styles.overview.items.mod(`columns${columns}`)()}>
					{items.map((item, i) => (
						<div className={styles.overview.items.item()} key={i}>
							<OverviewItem
								columns={columns}
								item={item}
								display_textual={display_textual}
							/>
						</div>
					))}
				</div>
			</Theme.Container>
		</Block>
	)
}

const OverviewItem: React.FC<
	{
		columns?: number
		item: DPOverviewItemBlock | DPOverviewLinkBlock | DPOverviewVideoBlock
	} & OverviewDisplaysType
> = ({columns, item, display_textual}) => {
	switch (item._type) {
		case 'overview_item':
			if (display_textual) {
				return <Textpreview text={item.text} link={item.link} />
			}

			return (
				<Cardpreview
					url={item.link?.url}
					image={item.image}
					text={item.text}
					text_mod={columns === 4 && ['small', 'full']}
					display_fallback={!item.image}
				/>
			)
		case 'overview_link':
			if (display_textual) {
				return (
					<Textpreview
						text={`
						<h5>${item.link?.title}</h5>
						<p>${item.link?.description}</p>
					`}
						link={item.link}
					/>
				)
			}

			return (
				<Cardpreview
					url={item.link?.url}
					image={item.link?.image}
					text={`
						<h5>${item.link?.title}</h5>
						<p>${item.link?.description}</p>
					`}
					text_mod={columns === 4 && ['small', 'full']}
					display_fallback={!item.link?.image}
				/>
			)
		case 'overview_video':
			if (display_textual) {
				return <Textpreview text={item.text} link={null} />
			}
			return (
				<div className={styles.videoblock()}>
					{item.text_above && (
						<CardpreviewContent
							text={item.text}
							text_mod={columns === 4 ? ['small', 'full', 'top'] : ['top']}
						/>
					)}
					<VideoBlock
						_type="videoblock"
						embed_code={item.embed_code}
						id={null}
						size={null}
						overview={true}
					/>
					{!item.text_above && (
						<CardpreviewContent
							text={item.text}
							text_mod={columns === 4 && ['small', 'full']}
						/>
					)}
				</div>
			)
	}
}
